import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "voucher-edit-form" };
const _hoisted_2 = { class: "form-content" };
const _hoisted_3 = { class: "form-section" };
const _hoisted_4 = { class: "cashback-section" };
const _hoisted_5 = { class: "cashback-display" };
const _hoisted_6 = { class: "cashback-text" };
const _hoisted_7 = { class: "amount-constraints" };
const _hoisted_8 = { class: "done-button-container" };
import { ref, computed, watch } from 'vue';
import InputSections from './InputSections.vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherEditForm',
    props: {
        initialAmount: {},
        availableVoucher: {},
        formatter: {}
    },
    emits: ["close", "update"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const amount = ref(props.initialAmount ?? 100);
        const errorText = ref(null);
        const sections = ref([
            {
                fields: [
                    {
                        id: 'amount',
                        type: props.availableVoucher.allowedAmounts ? 'select' : 'currency',
                        label: props.availableVoucher.allowedAmounts ? 'Select amount' : 'Enter amount',
                        value: props.initialAmount ?? 100,
                        required: true,
                        items: props.availableVoucher.allowedAmounts ? props.availableVoucher.allowedAmounts.split(',').map(Number) : [],
                        prefix: '£',
                        hideClear: true,
                    }
                ]
            }
        ]);
        function findFieldValueById(fieldId) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.id === fieldId && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function setFieldValueById(fieldId, value) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.id === fieldId) {
                        field.value = value;
                    }
                }
            }
        }
        const cashbackAmount = computed(() => {
            if (!findFieldValueById('amount'))
                return 0;
            return (findFieldValueById('amount') * props.availableVoucher?.effectiveDiscountPercentage || 0) / 100;
        });
        function validateAmount() {
            const newAmount = findFieldValueById('amount');
            errorText.value = null;
            if (amount.value && props.availableVoucher.upperAmount && parseFloat(newAmount) > props.availableVoucher.upperAmount) {
                setFieldValueById('amount', props.availableVoucher.upperAmount);
                errorText.value = "Maximum " + props.formatter.format(props.availableVoucher.upperAmount);
            }
            if (amount.value && props.availableVoucher.lowerAmount && parseFloat(newAmount) < props.availableVoucher.lowerAmount) {
                errorText.value = "Minimum " + props.formatter.format(props.availableVoucher.lowerAmount);
            }
        }
        function updateCashback() {
            amount.value = findFieldValueById('amount');
            emit('update', {
                amount: parseFloat(amount.value),
                cashback: cashbackAmount.value
            });
        }
        function validAmount() {
            amount.value = findFieldValueById('amount');
            errorText.value = null;
            if (!amount.value || amount.value === '' || isNaN(parseFloat(amount.value))) {
                errorText.value = "Please enter a valid amount";
                return false;
            }
            if (amount.value && props.availableVoucher.upperAmount && parseFloat(amount.value) > props.availableVoucher.upperAmount) {
                amount.value = props.availableVoucher.upperAmount;
                errorText.value = "Enter an amount no more than " + props.formatter.format(props.availableVoucher.upperAmount);
                return false;
            }
            if (amount.value && props.availableVoucher.lowerAmount && parseFloat(amount.value) < props.availableVoucher.lowerAmount) {
                errorText.value = "Enter an amount no less than " + props.formatter.format(props.availableVoucher.lowerAmount);
                return false;
            }
            return true;
        }
        function handleDone() {
            if (!validAmount()) {
                return;
            }
            updateCashback();
            emit('close');
        }
        watch(() => props.initialAmount, (newValue) => {
            if (newValue !== undefined) {
                amount.value = newValue;
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("label", { class: "form-label" }, "Value you would like to purchase", -1)),
                        _createElementVNode("div", null, [
                            _createVNode(InputSections, {
                                ref: "inputSections",
                                sections: sections.value,
                                theme: "white",
                                outline: true,
                                onInput: validateAmount
                            }, null, 8, ["sections"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatter.format(cashbackAmount.value)) + " cashback", 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", {
                                class: "constraints small",
                                style: _normalizeStyle(errorText.value ? 'font-weight:bold;color:#d32f2f;' : '')
                            }, " Minimum " + _toDisplayString(_ctx.formatter.format(_ctx.availableVoucher.lowerAmount)) + ". Maximum " + _toDisplayString(_ctx.formatter.format(_ctx.availableVoucher.upperAmount)) + ". " + _toDisplayString(_ctx.availableVoucher.minorUnit && _ctx.availableVoucher.minorUnit > 0 ? 'Increments of ' + _ctx.formatter.format(_ctx.availableVoucher.minorUnit) : '') + ". ", 5)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(MGButton, {
                                fullWidth: true,
                                text: "Update",
                                arrow: false,
                                onClick: handleDone,
                                class: "checkout-button"
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
